import React, { useContext, useState } from 'react';
import axios from 'axios';
import { Box, TextField, Button, Typography, Rating, Paper, Alert, CircularProgress } from '@mui/material';
import ENDPOINT from '../../data/ENDPOINT';
import { AuthContext } from '../../context/AuthContext';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const FeedbackForm = () => {
  const { user } = useContext(AuthContext);
  const { ticket_id } = useParams();
  const [formData, setFormData] = useState({
    rating: 0,
    message: '',
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRatingChange = (event, newValue) => {
    setFormData({ ...formData, rating: newValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    setLoading(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach(key => data.append(key, formData[key]));
      data.append('ticket_id', ticket_id);
      data.append('session', user.SessionId);

      const response = await axios.post(`${ENDPOINT}create_customer_feedback.php`, data);
      if (response.data.status === 'success') {
        setFormData({ rating: 0, message: '' });
        setSuccess(true);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError('Failed to submit feedback');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
    className='p-4'
      component={Paper}
      elevation={4}
      sx={{
        maxWidth: 450,
        mx: 'auto',
        my: 6,
      
        borderRadius: 3,
        background: '#f9f9f9'
      }}
    >
      <Typography variant="h5" fontWeight={600} mb={2} color="primary.main">
        Submit Your Feedback
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        We value your feedback. Please rate your experience and leave a comment.
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>Thank you for your feedback!</Alert>}
      <form onSubmit={handleSubmit}>
        <Box mb={3}>
          <Typography component="legend" fontWeight={500}>Your Rating</Typography>
          <Rating
            name="rating"
            value={formData.rating}
            onChange={handleRatingChange}
            precision={1}
            max={5}
            size="large"
            sx={{ mt: 1 }}
          />
        </Box>
        <TextField
          fullWidth
          label="Your Message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          margin="normal"
          multiline
          rows={4}
          required
          variant="outlined"
        />
        <Box mt={4} display="flex" justifyContent="flex-end">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            size="large"
            sx={{ minWidth: 120, borderRadius: 2 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default FeedbackForm;